import React, { useState } from 'react';

const IconCoins = ({
    size = 16,
    stroke = 2,
    color = "currentColor",
    hoverColor = "#1890ff",
    marginRight = 8
}) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            strokeWidth={stroke}
            fill={isHovered ? hoverColor : color}
            stroke="none"
            style={{
                transition: "fill 0.3s ease",
                marginRight: `${marginRight}px`,
                marginLeft: "-4px",
                transform: "translateY(3px)", // <- aquí se baja
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z" />
            <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4" />
            <path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z" />
            <path d="M3 6v10c0 .888 .772 1.45 2 2" />
            <path d="M3 11c0 .888 .772 1.45 2 2" />
        </svg>
    );
};

export default IconCoins;
